"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const ScaffoldingContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: SpaceMd
});
export {
  ScaffoldingContainer
};
